export const ACTION = {
    RESEND_OTP: 'RESEND_OTP',
};